export class  FnCloudFile{
    fileName: string;
	type: string;
	mimeType: string;
	isUnencrypted: boolean;
	storageType: string;
	contentLength?: number;
	remoteID?: number;
	primaryKey?: number;
	fileId?: number;
	isArchive?: boolean;
	headerPK?: number;
	entityName?: string;
	usingJavaApi?: boolean;
	canDeleteFile?: boolean;
	uniqueKey?: string;
	fileIcon?: string;
}